(function () {
  'use strict';

  const header = document.querySelector('[data-header]');
  if (!header) return;

  const wrapper = header.querySelector('[data-mega-menu]');
  if (!wrapper) return;

  let activeHandle = null;
  let overlay = null;
  let leaveTimer = null;
  let closing = false;
  const EB = 'cubic-bezier(0.42, 0, 0.58, 1)';
  const root = document.documentElement;
  const group = document.querySelector('[data-header-group]');
  let groupResetTimer = 0;

  // A transform on the group makes it the containing block for the fixed mega panel.
  // The :has() open override keeps it transform-neutral but drops when data-active flips
  // false — while the panel still animates out. Pin it inline through the close, then snap
  // back with no transition. Mirrors menu-drawer.js.
  function holdGroupThroughClose() {
    if (!group || !group.hasAttribute('data-header-sticky')) return;
    group.style.transition = 'none';
    group.style.translate = 'none';
    group.style.top = 'calc(-1 * var(--announcement-bar-height))';
    clearTimeout(groupResetTimer);
    groupResetTimer = setTimeout(function () {
      group.style.translate = '';
      group.style.top = '';
      void group.offsetWidth;                 // commit the resting transform instantly
      requestAnimationFrame(function () { group.style.transition = ''; });
    }, 650);                                    // 300ms fade + 300ms slide + buffer
  }

  // Overlay is created dynamically (unlike the drawer's Liquid-rendered overlay)
  // because the mega-menu overlay must sit on <body> at z-30, below the header's z-40,
  // so it visually covers only the content below the header.

  // --- Panel top offset — pins the panel to the header's live bottom edge ---
  // Panels are `fixed`, not `absolute`/`top-full`, so they sit flush against the
  // header regardless of the announcement bar rendering above it (or not) and
  // regardless of the header's sticky-fixed scrolled state — via getBoundingClientRect()
  // since that already returns viewport-relative coordinates in both states.
  function updateMegaOffset() {
    root.style.setProperty('--mega-panel-top-offset', header.getBoundingClientRect().bottom + 'px');
  }

  updateMegaOffset();
  window.addEventListener('scroll', updateMegaOffset, { passive: true });
  window.addEventListener('resize', updateMegaOffset);
  new MutationObserver(updateMegaOffset).observe(group || header, {
    attributes: true,
    attributeFilter: ['data-header-sticky'],
  });
  if (typeof ResizeObserver === 'function') new ResizeObserver(updateMegaOffset).observe(header);

  function getPanel(handle) {
    return wrapper.querySelector('[data-mega-panel="' + handle + '"]');
  }

  function getFadeable(panel) {
    var result = [];
    var children = panel.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el.hasAttribute('data-mega-persist')) continue;
      if (el.querySelector('[data-mega-persist]')) {
        var subs = el.children;
        for (var j = 0; j < subs.length; j++) {
          if (!subs[j].hasAttribute('data-mega-persist')) result.push(subs[j]);
        }
      } else {
        result.push(el);
      }
    }
    return result;
  }

  function anim(el, kf, ms) {
    return el.animate(kf, { duration: ms, easing: EB, fill: 'forwards' });
  }

  function ensureOverlay() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:30;display:none;';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', closeMenu);
  }

  function showOverlay() {
    ensureOverlay();
    overlay.style.display = '';
    anim(overlay, [{ opacity: 0 }, { opacity: 1 }], 300);
  }

  function hideOverlay() {
    if (!overlay) return;
    const a = anim(overlay, [{ opacity: 1 }, { opacity: 0 }], 300);
    a.finished.then(function () { overlay.style.display = 'none'; });
  }

  function setTriggerState(trigger, isActive) {
    trigger.setAttribute('data-active', isActive ? 'true' : 'false');
    trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  }

  function openPanel(handle, trigger) {
    const panel = getPanel(handle);
    if (!panel) return;
    activeHandle = handle;
    // Re-opened mid-close: cancel the pending snap-back (the :has() override takes over).
    clearTimeout(groupResetTimer);
    updateMegaOffset();
    header.querySelectorAll('[data-mega-trigger]').forEach(function (t) { setTriggerState(t, t === trigger); });
    showOverlay();
    root.setAttribute('data-scroll-lock', '');
    panel.classList.remove('hidden');
    anim(panel, [{ transform: 'translateY(-100%)' }, { transform: 'translateY(0)' }], 300);
    var fadeable = getFadeable(panel);
    fadeable.forEach(function (el) { el.style.opacity = '0'; });
    setTimeout(function () { fadeable.forEach(function (el) { anim(el, [{ opacity: 0 }, { opacity: 1 }], 300); }); }, 300);
  }

  function switchPanel(handle, trigger) {
    const oldPanel = getPanel(activeHandle);
    const newPanel = getPanel(handle);
    if (!oldPanel || !newPanel) return;
    getFadeable(oldPanel).forEach(function (el) { anim(el, [{ opacity: 1 }, { opacity: 0 }], 300); });
    const oldTrigger = header.querySelector('[data-mega-trigger="' + activeHandle + '"]');
    if (oldTrigger) setTriggerState(oldTrigger, false);
    setTriggerState(trigger, true);
    setTimeout(function () {
      oldPanel.classList.add('hidden');
      newPanel.classList.remove('hidden');
      activeHandle = handle;
      const nf = getFadeable(newPanel);
      nf.forEach(function (el) { el.style.opacity = '0'; anim(el, [{ opacity: 0 }, { opacity: 1 }], 300); });
    }, 300);
  }

  function closeMenu() {
    if (!activeHandle) return;
    closing = true;
    const panel = getPanel(activeHandle);
    const closingHandle = activeHandle;
    activeHandle = null;
    header.querySelectorAll('[data-mega-trigger]').forEach(function (t) { setTriggerState(t, false); });
    holdGroupThroughClose();
    if (!panel) { closing = false; return; }
    getFadeable(panel).forEach(function (el) { anim(el, [{ opacity: 1 }, { opacity: 0 }], 300); });
    // The persist element (FAQs/Contact) is excluded from getFadeable so it survives panel
    // switches. A close has nothing following it, so fade it here too, otherwise a tall panel's
    // FAQ strip sweeps up at full opacity during the slide. Cancel on hide to restore it.
    const persist = panel.querySelector('[data-mega-persist]');
    const persistAnim = persist ? anim(persist, [{ opacity: 1 }, { opacity: 0 }], 300) : null;
    setTimeout(function () {
      const a = anim(panel, [{ transform: 'translateY(0)' }, { transform: 'translateY(-100%)' }], 300);
      a.finished.then(function () {
        panel.classList.add('hidden');
        // Clear the slide's forwards-fill so the panel isn't left at translateY(-100%); switchPanel
        // doesn't re-slide, so otherwise it would later show this panel translated off-screen.
        a.cancel();
        if (persistAnim) persistAnim.cancel();
        closing = false;
      });
      hideOverlay();
      root.removeAttribute('data-scroll-lock');
    }, 300);
    const trigger = header.querySelector('[data-mega-trigger="' + closingHandle + '"]');
    if (trigger) trigger.focus();
  }

  // Trigger clicks — delegated on header since triggers are in header-nav-desktop
  header.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-mega-trigger]');
    if (!trigger) return;
    e.preventDefault();
    if (closing) return;
    const handle = trigger.getAttribute('data-mega-trigger');
    if (activeHandle === handle) closeMenu();
    else if (activeHandle) switchPanel(handle, trigger);
    else openPanel(handle, trigger);
  });

  // Close on mouseleave from entire header (nav + mega panels)
  header.addEventListener('mouseleave', function () {
    if (!activeHandle) return;
    leaveTimer = setTimeout(closeMenu, 150);
  });
  header.addEventListener('mouseenter', function () {
    if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeHandle) closeMenu();
  });
})();
